import { createContext } from 'react';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import { renderRoot } from 'quartz-core/client';
import { Provider } from 'react-redux';
import { RhumbProvider } from 'react-rhumb';
import staticAdapter from 'react-rhumb/staticAdapter';
import rhumbConfig from '../rhumb-config.yaml';
import configureStore from './utils/configureStore';
import Preview from './containers/Preview';
import LiveSurvey from './containers/LiveSurvey';
import { SubmissionUpdatesProvider } from './hooks/useSubmissionUpdates';
import { getInitialQueryParams } from './utils/getInitialQueryParams';
import { SurveyConfigProvider } from './hooks/useSurveyConfig';
import { getJasmine, getLocation } from './utils/windowUtils';
import UIApplication from 'UIComponents/app/UIApplication';

// @ts-expect-error expects an argument but doesnt need one
import { jsx as _jsx } from "react/jsx-runtime";
const I18nContext = /*#__PURE__*/createContext();
export default class Application {
  start() {
    if (getJasmine()) return;
    // @ts-expect-error it's there
    window.AppInstance = this;
    const I18nProvider = createPublicI18nProvider();
    const langAvailable = Promise.all([I18nProvider.register(lang)]);
    langAvailable.then(() => {
      setDocumentTitle('feedbackPublicUi.htmlTitle');
      this.startRedux(I18nProvider);
    }).catch(console.error);
  }
  startRedux(I18nProvider) {
    // @ts-expect-error it's ok
    this.store = configureStore({});
    const params = getInitialQueryParams(getLocation().search.replace(/^\?/, ''));
    const surveyPath = getLocation().pathname.split('/')[1];
    const surveyType = surveyPath.toUpperCase();
    const SubmissionComponent = params.isPreview ? Preview : LiveSurvey;
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "feedback-public-submission-ui",
      children: /*#__PURE__*/_jsx(I18nContext.Provider, {
        value: I18nProvider,
        children: /*#__PURE__*/_jsx(RhumbProvider
        // @ts-expect-error it's got it
        , {
          config: rhumbConfig,
          history: staticAdapter(`/${surveyPath}`),
          children: /*#__PURE__*/_jsx(Provider, {
            store: this.store,
            children: /*#__PURE__*/_jsx(SurveyConfigProvider, {
              children: /*#__PURE__*/_jsx(SubmissionUpdatesProvider, {
                children: /*#__PURE__*/_jsx(SubmissionComponent, {
                  params: params,
                  surveyType: surveyType
                })
              })
            })
          })
        })
      })
    }));
  }
}